import { render } from "./ChatMessageFile.vue?vue&type=template&id=5ac9609f&scoped=true"
import script from "./ChatMessageFile.vue?vue&type=script&lang=js"
export * from "./ChatMessageFile.vue?vue&type=script&lang=js"

import "./ChatMessageFile.vue?vue&type=style&index=0&id=5ac9609f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac9609f"]])

export default __exports__